export default "__VITE_ASSET__XJ1FFZb3__"